import api from '@/ts/api';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';

export const Store = defineStore('store', {
  state: () => ({ 
      logged : useStorage('logged', false),    
      lang : useStorage('geolang', 'en'),    
      limit : useStorage('limit', 20),    
      
      memory: undefined,
      search: undefined,
      get: undefined,
      token: undefined,
      langs: undefined,
      city: undefined,
      size: undefined,
  }),
  
  actions: {

    //login
    async login(login, pass){
      let res = await api.send('login',{login, pass})                
      if (res.error) return res
      this.logged = true
      return res
    },

    // выход из текущего аккаунта и переключение на следующий
    async logout(){

      const res = await api.logout()
      if (!res){
        console.error("no api result")
       
        return
      }
      if (res.error) {
        console.error(res.error)
       
        return
      }

        // удаляем куки
        console.log("logout clear")
        this.logged = false
        
        window.location = '/'
        return
    },


  },
})

